import React from "react";

const IconWhiteLabel = ({
  defaultFilled = "var(--mantine-color-gray-5)",
  withBackground = true,
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 141 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {withBackground && (
        <>
          <path
            d="M0 55C0 48.3726 5.37258 43 12 43H61C67.6274 43 73 48.3726 73 55V67C73 73.6274 67.6274 79 61 79H12C5.37259 79 0 73.6274 0 67V55Z"
            fill="#fcfbff"
            className="fill-secondary-on-hover-target"
          />
          <path
            d="M66 13C66 6.37258 71.3726 1 78 1H127C133.627 1 139 6.37258 139 13V25C139 31.6274 133.627 37 127 37H78C71.3726 37 66 31.6274 66 25V13Z"
            fill="#fcfbff"
            className="fill-white-on-hover-target"
          />
        </>
      )}
      <path
        d="M63.88 79.7698H10.26C4.61 79.7698 0 75.1698 0 69.5098V52.5998C0 46.9498 4.6 42.3398 10.26 42.3398H63.88C69.53 42.3398 74.14 46.9398 74.14 52.5998V69.5098C74.14 75.1598 69.54 79.7698 63.88 79.7698ZM10.26 46.2398C6.74 46.2398 3.88 49.0998 3.88 52.6198V69.5298C3.88 73.0498 6.74 75.9099 10.26 75.9099H63.88C67.4 75.9099 70.26 73.0498 70.26 69.5298V52.6198C70.26 49.0998 67.4 46.2398 63.88 46.2398H10.26Z"
        fill={defaultFilled}
        className="fill-secondary-on-hover-target"
      />
      <path
        d="M45.6903 56.5792H13.7603C12.6903 56.5792 11.8203 55.7092 11.8203 54.6392C11.8203 53.5692 12.6903 52.6992 13.7603 52.6992H45.6903C46.7603 52.6992 47.6303 53.5692 47.6303 54.6392C47.6303 55.7092 46.7603 56.5792 45.6903 56.5792Z"
        fill={defaultFilled}
        className="fill-white-on-hover-target"
      />
      <path
        d="M45.6903 69.4288H13.7603C12.6903 69.4288 11.8203 68.5588 11.8203 67.4888C11.8203 66.4188 12.6903 65.5488 13.7603 65.5488H45.6903C46.7603 65.5488 47.6303 66.4188 47.6303 67.4888C47.6303 68.5588 46.7603 69.4288 45.6903 69.4288Z"
        fill={defaultFilled}
        className="fill-white-on-hover-target"
      />
      <path
        d="M59.3811 64.7491C61.3196 64.7491 62.8911 63.0971 62.8911 61.0591C62.8911 59.0212 61.3196 57.3691 59.3811 57.3691C57.4426 57.3691 55.8711 59.0212 55.8711 61.0591C55.8711 63.0971 57.4426 64.7491 59.3811 64.7491Z"
        fill={defaultFilled}
        className="fill-white-on-hover-target"
      />
      <path
        d="M28.2688 32.3695C28.0388 32.3695 27.8088 32.3495 27.5688 32.2995C25.7288 31.9195 24.5588 30.1195 24.9388 28.2795C27.8088 14.5295 38.5288 3.66954 52.2388 0.619537C54.0688 0.209537 55.8788 1.36954 56.2888 3.19954C56.6988 5.02954 55.5388 6.83954 53.7088 7.24954C42.5888 9.72954 33.8988 18.5295 31.5788 29.6795C31.2488 31.2795 29.8288 32.3795 28.2588 32.3795H28.2688V32.3695Z"
        fill={defaultFilled}
        className="fill-secondary-on-hover-target"
      />
      <path
        d="M80.1687 95.529C76.4087 95.529 72.6587 94.989 69.0187 93.939C67.2187 93.419 66.1787 91.529 66.7087 89.729C67.2287 87.929 69.1187 86.889 70.9187 87.419C73.9387 88.299 77.0487 88.739 80.1687 88.739C98.3887 88.739 113.209 73.919 113.209 55.699V55.239C113.169 53.359 114.669 51.819 116.539 51.799C118.429 51.779 119.959 53.269 119.979 55.149V55.299C119.979 55.429 119.989 55.569 119.989 55.709C119.989 77.669 102.119 95.539 80.1587 95.539L80.1687 95.529Z"
        fill={defaultFilled}
      />
      <path
        d="M129.97 0H76.35C70.69 0 66.09 4.61 66.09 10.26V27.16C66.09 32.82 70.69 37.42 76.35 37.42H129.97C135.63 37.43 140.23 32.82 140.23 27.17V10.26C140.23 4.6 135.62 0 129.97 0ZM111.78 27.07H79.85C78.78 27.07 77.91 26.2 77.91 25.13C77.91 24.06 78.78 23.19 79.85 23.19H111.78C112.85 23.19 113.72 24.06 113.72 25.13C113.72 26.2 112.85 27.07 111.78 27.07ZM111.78 14.26H79.85C78.78 14.26 77.91 13.39 77.91 12.32C77.91 11.25 78.78 10.38 79.85 10.38H111.78C112.85 10.38 113.72 11.25 113.72 12.32C113.72 13.39 112.85 14.26 111.78 14.26ZM125.46 22.4C123.52 22.4 121.95 20.75 121.95 18.71C121.95 16.67 123.52 15.02 125.46 15.02C127.4 15.02 128.97 16.67 128.97 18.71C128.97 20.75 127.4 22.4 125.46 22.4Z"
        fill={defaultFilled}
      />
    </svg>
  );
};

export default IconWhiteLabel;
